export var selectCurrentModalWithType = function (type) { return function (state) {
    var stack = state.modals.modalStack.filter(function (val) { return val.type === type; });
    var currentModal = stack[stack.length - 1];
    if (currentModal == undefined) {
        return {};
    }
    return {
        ComponentType: currentModal.domComponent,
    };
}; };



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectCurrentModalWithType.ts
// module id = 379
// module chunks = 3